/**
 * How an order reaches the person who ordered it. Mirrors
 * `domain/Orders/Enums/DeliveryType.php`, which is shared with the POS and the
 * other sales channels — so it carries cases Pjazza itself never places.
 *
 * Pjazza only ever writes `dine_in` or `takeaway`. The other four are here
 * because the account's order history is fed from the orders table rather than
 * from this app's own writes, and because the alternative — a two-way ternary —
 * printed "takeaway" against a delivery.
 */
const DELIVERY_TYPE = {
  PICKUP: 'pickup',
  OWN_DELIVERY: 'own_delivery',
  DELIVERY: 'delivery',
  TAKEAWAY: 'takeaway',
  RETAIL: 'retail',
  DINE_IN: 'dine_in'
} as const

type DeliveryType = (typeof DELIVERY_TYPE)[keyof typeof DELIVERY_TYPE]

/** Lower case: these sit mid-sentence, after the status, on an order row. */
const DELIVERY_TYPE_LABEL: Record<DeliveryType, string> = {
  pickup: 'collection',
  own_delivery: 'delivery',
  delivery: 'delivery',
  takeaway: 'takeaway',
  retail: 'in store',
  dine_in: 'dine in'
}

export { DELIVERY_TYPE, DELIVERY_TYPE_LABEL }
export type { DeliveryType }
